import { useEffect, useState } from 'react';
import {
  isAssistantDesktopViewport,
  subscribeAssistantViewport,
} from '../utils/assistantDisplayMode';

/** Tracks whether the viewport is at or above the assistant rail breakpoint (1024px). */
export function useAssistantViewport(): boolean {
  const [isDesktop, setIsDesktop] = useState(() => isAssistantDesktopViewport());

  useEffect(() => subscribeAssistantViewport(setIsDesktop), []);

  return isDesktop;
}
